import { useCallback, useState } from 'react';

import { MochiButton, MochiModalV2 } from '@autopass-web/mochi-component';

import styles from './modal.module.sass';

import type { ReactNode } from 'react';

export type ModalProps = {
  isOpen: boolean;
  children: ReactNode;
  title: string;
  actions?: ReactNode;
  action?: ReactNode;
  closeActionText?: string;
  onClose: () => void;
};

export const Modal = (props: ModalProps) => {
  const { isOpen, children, title, onClose, closeActionText, actions } = props;
  return (
    <MochiModalV2.Root isOpen={isOpen} onClose={onClose}>
      <MochiModalV2.Header>{title}</MochiModalV2.Header>
      <MochiModalV2.Body className="text-center">{children}</MochiModalV2.Body>
      <MochiModalV2.Footer className="flex justify-center pb-6 pt-4">
        {props?.actions ? (
          actions
        ) : (
          <MochiButton variant="text" onClick={onClose}>
            {closeActionText}
          </MochiButton>
        )}
      </MochiModalV2.Footer>
    </MochiModalV2.Root>
  );
};

export const ModalLayout = ({
  children,
  title,
  onClose,
  closeActionText,
}: Pick<ModalProps, 'children' | 'title' | 'onClose' | 'closeActionText'>) => {
  return (
    <div className={styles.modalLayout}>
      <MochiModalV2.Header>{title}</MochiModalV2.Header>
      <MochiModalV2.Body className="text-center">{children}</MochiModalV2.Body>
      <MochiModalV2.Footer className="flex justify-center pb-6">
        <MochiButton variant="text" onClick={onClose}>
          {closeActionText}
        </MochiButton>
      </MochiModalV2.Footer>
    </div>
  );
};

export const useModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  const onClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  const onOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  return {
    isOpen,
    onClose,
    onOpen,
  };
};
